/*jslint browser: true, plusplus: true */
(function ($, window, document) {
    'use strict';

    $(document).ready(function () {
        $('.cancelSubscription').on('click', function(event){
			event.preventDefault();
			
			var cconfirm = confirm('Are you sure you want to cancel the subscription?');
			if (cconfirm == true){
				var sub_id = $(this).attr('data-id');
				var order_gateway = $(this).attr('data-gateway');
				
				var form = document.getElementById("afpuser-subscription-form");
				$(form).append('<input type="hidden" name="sub_id" id="sub_id" value="'+sub_id+'"/>');
				$(form).append('<input type="hidden" name="order_gateway" id="order_gateway" value="'+order_gateway+'"/>');
				form.submit();
			}
		});
		
		$('.editCard').on('click', function(event){
			event.preventDefault();
			
			$(this).parents('tr').find('.expDate').hide();
			var cardNumber = $(this).attr('data-card');
			var expMonth = $(this).attr('data-month');
			var expYear = $(this).attr('data-year');
			var payment_id = $(this).attr('data-id');
			
			$(this).parents('tr').find('.expField').append('<input type="hidden" name="payment_id" id="payment_id" value="'+payment_id+'"/><input type="hidden" name="cardNumber" id="cardNumber" value="'+cardNumber+'"/><input type="text" name="expMonth" id="expMonth" value="'+expMonth+'" pattern="[0-9]*" maxlength="2" size="2" placeholder="MM"> / <input type="text" name="expYear" id="expYear" value="'+expYear+'" pattern="[0-9]*" maxlength="4" size="4" placeholder="YYYY"/>');
			$(this).parents('tr').find('.expField').show();
			$(this).parents('tr').find('input:submit[name=updateCard]').show();
			$(this).parents('tr').find('.editCard').hide();
		});
		
		$('form[name=afpuser-payprofile-form]').on('submit', function(event){
			var $this = this;
			
			const d = new Date();
			let year = d.getFullYear();
			
			var expYear = $($this).find('input:text[name=expYear]').val();
			var expMonth = $($this).find('input:text[name=expMonth]').val();
			
			if (expMonth == '' || expMonth == 0 || expMonth == '00' || expMonth > 12 || expMonth < 0) {
				$('.afpuserbilling-block').prepend('<p class="message afp_animate afp_fadeout"><span class="afperror">Please enter a valide month</span></p>');
				$($this).find('input:text[name=expYear]').focus();
				event.preventDefault();
			} else if (expYear == '' || expYear < year) {
				$('.afpuserbilling-block').prepend('<p class="message afp_animate afp_fadeout"><span class="afperror">Please enter a valide Year</span></p>');
				$($this).find('input:text[name=expYear]').focus();
				event.preventDefault();
			} else {
				if ($('.afp_animate').length > 0) {
					$('.afp_animate').remove();
				}
			}
		});
    });

}(jQuery, window, document));